import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import IConfigurationModel, { ConfigurationModel } from '@/models/configuration-model';
import nameSettings from '@/settings/name-settings.json'

export type Getters = {
  configBagsizeId(state: State): string | null | undefined;
  configBodyId(state: State): string | null | undefined;
  configEdgeId(state: State): string | null | undefined;
  configThreadId(state: State): string | null | undefined;
  configInsideId(state: State): string | null | undefined
  configPocketId(state: State): string | null | undefined
  configSideId(state: State): string | null | undefined
  configFrontId(state: State): string | null | undefined
  configTackId(state: State): string | null | undefined
  configBackId(state: State): string | null | undefined
  configNamechar(state: State): string | null | undefined
  configNamethreadId(state: State): string | null | undefined
  configNonameId(state: State): string | null | undefined

  isRainbowConfig(state: State): boolean
  configLoaded(state: State): boolean
  currentConfig(state: State): IConfigurationModel
  isAllConfigSet(state: State): boolean
}

export const getters: GetterTree<State, RootState> & Getters = {
  configBagsizeId: (state) => state.configBagsizeId,
  configBodyId: (state) => state.configBodyId,
  configEdgeId: (state) => state.configEdgeId,
  configThreadId: (state) => state.configThreadId,
  configInsideId: (state) => state.configInsideId,
  configPocketId: (state) => state.configPocketId,
  configSideId: (state) => state.configSideId,
  configFrontId: (state) => state.configFrontId,
  configTackId: (state) => state.configTackId,
  configBackId: (state) => state.configBackId,
  configNamechar: (state) => state.configNamechar,
  configNamethreadId: (state) => state.configNamethreadId,
  configNonameId: (state) => state.configNonameId,

  isRainbowConfig: (state) => state.configThreadId == '12',
  configLoaded: (state) => state.configLoaded,

  currentConfig: (state) => {
    let model = new ConfigurationModel()
    model.bagsize = state.configBagsizeId || null
    model.body = state.configBodyId || null
    model.edge = state.configEdgeId || null
    model.thread = state.configThreadId || null
    model.inside = state.configInsideId || null
    model.pocket = state.configPocketId || null
    model.side = state.configSideId || null
    model.front = state.configFrontId || null
    model.tack = state.configTackId || null
    model.back = state.configBackId || null
    model.namechar = state.configNamechar || null
    model.namethread = state.configNamethreadId || null
    model.noName = state.configNonameId || null
    return model
  },

  isAllConfigSet: (state) => {
    const isNoName = state.configNonameId == nameSettings.noName.id
    const isYesName = state.configNonameId == nameSettings.yesName.id && state.configNamechar && state.configNamechar.length > 0 && state.configNamethreadId

    if (state.configBagsizeId && state.configBodyId && state.configEdgeId && state.configThreadId &&
      state.configInsideId && state.configPocketId && state.configSideId && state.configFrontId &&
      state.configTackId && state.configBackId && (isNoName || isYesName)) {
      return true
    }
    else {
      return false
    }
  }
};
